<script lang="ts">
    
    import type { SvelteComponent } from "svelte";
    import type { ActivitiesMap, AnyActivity } from "../../global";
    import { ChatActivity } from "../../Model/ChatActivity";
    import { GalleryActivity } from "../../Model/GalleryActivity";
    import { Image360Activity } from "../../Model/Image360Activity";
    import { InfoActivity } from "../../Model/InfoActivity";
    import { SecretActivity } from "../../Model/SecretActivity";
    import Chat from "../Chat/Chat.svelte";
    import Gallery from "../Gallery/Gallery.svelte";
    import Image360 from "../Image360/Image360.svelte";
    import Info from "../Info/Info.svelte";
    import Secret from "../Secret/Secret.svelte";

    export let activity: AnyActivity;

    const activityComponentsMap: Record<keyof ActivitiesMap, typeof SvelteComponent> = {
        chat: Chat,
        info: Info,
        secret: Secret,
        gallery: Gallery,
        image360: Image360,
    };

    let activityType: keyof ActivitiesMap;

    $: updateActivityType(activity);

    function updateActivityType(activity: AnyActivity): void {
        if (activity instanceof ChatActivity) {
            activityType = 'chat';
        } else if (activity instanceof InfoActivity) {
            activityType = 'info';
        } else if (activity instanceof SecretActivity) {
            activityType = 'secret';
        } else if (activity instanceof GalleryActivity) {
            activityType = 'gallery';
        } else if (activity instanceof Image360Activity) {
            activityType = 'image360';
        } else {
            activityType = undefined;
        }
    }

</script>

{#if activityType}
    <svelte:component this={activityComponentsMap[activityType]} {activity} on:close />
{/if}